import type { MutableRefObject } from 'react';
import { useRef } from 'react';

/**
 * This hook provides a ref which is perpetually up to date but will not trigger any renders.
 * This is useful for resolving circular references in dependency arrays.
 * @param currentValue The value you wish to track
 */
export default function useNoRenderRef<T>(currentValue: T): MutableRefObject<T> {
  const ref = useRef(currentValue);
  ref.current = currentValue;
  return ref;
}
